/* ===========================================================================
   Vector rebuild of the logo mark's hexagon cluster.

   Reverse-engineered from the shipped PNG: three identical pointy-top
   hexagons (circumradius 60, stroke 16.6) whose centres sit on an equilateral
   triangle of side 54 — pink at the apex, cyan bottom-left, amber
   bottom-right. That construction reproduces the original's 172:181
   proportion almost exactly.

   Used only where the mark has to be drawn, scaled or animated (the loader,
   the footer rule). Everywhere the *logo* appears, the original PNG is used.
   =========================================================================== */

const R = 60;
const STROKE = 16.6;
const S = 54; // side of the centre triangle
const TRI_H = (S * Math.sqrt(3)) / 2;

const CENTERS = {
  pink: [0, -(TRI_H * 2) / 3],
  cyan: [-S / 2, TRI_H / 3],
  amber: [S / 2, TRI_H / 3],
};

const HEX_PATH = (() => {
  const pts = [];
  for (let i = 0; i < 6; i += 1) {
    const a = ((60 * i - 90) * Math.PI) / 180;
    pts.push(`${(R * Math.cos(a)).toFixed(2)},${(R * Math.sin(a)).toFixed(2)}`);
  }
  return `M${pts.join("L")}Z`;
})();

export default function HexMark({ className = "", strokeWidth = STROKE, title }) {
  return (
    <svg
      className={`hex-mark ${className}`}
      viewBox="-92 -104 184 192"
      role={title ? "img" : "presentation"}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : "true"}
      fill="none"
    >
      <g strokeWidth={strokeWidth} strokeLinejoin="miter">
        {Object.entries(CENTERS).map(([name, [cx, cy]]) => (
          <path
            key={name}
            className={`hex-mark__ring hex-mark__ring--${name}`}
            d={HEX_PATH}
            transform={`translate(${cx.toFixed(2)} ${cy.toFixed(2)})`}
            stroke={`var(--mark-${name})`}
          />
        ))}
      </g>

      {/* The circuit wired between the cells. */}
      <g className="hex-mark__circuit" strokeWidth="7" strokeLinecap="round">
        <path d="M-19 6 L-19 43" stroke="var(--mark-amber)" />
        <path d="M-19 6 L-13 -27" stroke="var(--mark-cyan)" />
        <path d="M1 27 L17 -5" stroke="var(--mark-pink)" />
        <circle cx="-19" cy="6" r="9" stroke="var(--mark-amber)" fill="var(--mark-node-fill, var(--surface))" />
        <circle cx="17" cy="-5" r="9" stroke="var(--mark-cyan)" fill="var(--mark-node-fill, var(--surface))" />
        <circle cx="1" cy="27" r="9" stroke="var(--mark-pink)" fill="var(--mark-node-fill, var(--surface))" />
      </g>
    </svg>
  );
}
